// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2CnfE","title":"AfterFrontImage_title__2lVY3"};